var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeelabxLockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5A623",
    fillRule: "evenodd",
    d: "M26 0 52 15v30L26 60 0 45V15Z M26 8.5 7.5 19.2v21.6L26 51.5l18.5-10.7V19.2Z M26 23a7 7 0 1 1 0 14a7 7 0 0 1 0-14Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 41,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    letterSpacing: -0.8,
    fill: "#1A1A1A"
  }, "BeelabX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeelabxLockup);
export default __webpack_public_path__ + "static/media/beelabx-lockup.087f357f0d7924d9300f3f5e9d69ae6a.svg";
export { ForwardRef as ReactComponent };